import { getPerMachineSummarySale, getPerMachineTotalSale } from '@apis/perMachine';
import { PERMACHINE } from '@components/perMachine/queryKey/queryKey';
import {
  OrderOption,
  perMachineSummarySalesData,
  perMachineTotalSalesData,
} from '@dataTypes/perMachineTypes';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

export const useGetMachineTotalSalesList = (
  storeId: number | undefined,
  startDate: string,
  endDate: string,
  order?: OrderOption,
) => {
  const [isLoading, setIsLoading] = useState(true);

  const {
    data: getPerMachineSaleData,
    isLoading: getPerMachineSaleDataLoading,
    isFetching: getPerMachineSaleDataFetching,
  } = useQuery<perMachineTotalSalesData[]>(
    [PERMACHINE.PERMACHINESALESLISTS, startDate, endDate, storeId, order],
    () => getPerMachineTotalSale(storeId, startDate, order),
    {
      enabled: !!storeId && startDate === endDate,
      staleTime: 30000,
      cacheTime: 30000,
    },
  );

  const {
    data: getPerMachineSummarySaleData,
    isLoading: getPerMachineSummarySaleDataLoading,
    isFetching: getPerMachineSummarySaleDataFetching,
  } = useQuery<perMachineSummarySalesData[]>(
    [PERMACHINE.PERMACHINESUMMARYSALESLISTS, startDate, endDate, storeId, order],
    () => getPerMachineSummarySale(storeId, startDate, endDate, order),
    {
      enabled: !!storeId && startDate !== endDate,
      staleTime: 30000,
      cacheTime: 30000,
    },
  );

  useEffect(() => {
    const sameDate = startDate === endDate;
    if (sameDate) {
      // 데이터가 이미 있을 때는 isFetching을 무시하고 isLoading만 사용
      if (getPerMachineSaleDataLoading) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    } else {
      // 데이터가 이미 있을 때는 isFetching을 무시하고 isLoading만 사용
      if (getPerMachineSummarySaleDataLoading) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [
    getPerMachineSaleDataLoading,
    getPerMachineSummarySaleDataLoading,
    getPerMachineSaleDataFetching,
    getPerMachineSummarySaleDataFetching,
  ]);

  return {
    getPerMachineSaleData,
    getPerMachineSummarySaleData,
    isLoading,
  };
};
